module.exports = __webpack_public_path__ + "static/media/211ME142.1683fc24.jpg";